import React from "react";
var __jsx = React.createElement;
import { Calendar, RangeCalendar } from "@mantine/dates";
import { CalendarHeader } from "./calendar-header";
import { CALENDAR_STYLES } from "./date-field-styles";
import { buildTodayDayStyle } from "./today-highlight";
/** Month/year header + Mantine day grid for single, datetime, and day-mode range. */
export function DayCalendarBody(_ref) {
  var type = _ref.type,
    month = _ref.month,
    onMonthChange = _ref.onMonthChange,
    singleValue = _ref.singleValue,
    rangeValue = _ref.rangeValue,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onSelectSingle = _ref.onSelectSingle,
    onSelectRange = _ref.onSelectRange,
    onRequestClose = _ref.onRequestClose,
    highlightToday = _ref.highlightToday,
    testId = _ref.testId;
  var dayStyle = buildTodayDayStyle(highlightToday);
  var handleSingle = function handleSingle(date) {
    onSelectSingle(date);
    if (type === "single") onRequestClose();
  };
  var handleRange = function handleRange(range) {
    onSelectRange(range);
    if (range[0] && range[1]) onRequestClose();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-[280px]"
  }, /*#__PURE__*/React.createElement(CalendarHeader, {
    month: month,
    onMonthChange: onMonthChange,
    minDate: minDate,
    maxDate: maxDate,
    testId: testId
  }), type === "range" ? /*#__PURE__*/React.createElement(RangeCalendar, {
    value: rangeValue,
    onChange: handleRange,
    month: month,
    onMonthChange: onMonthChange,
    allowSingleDateInRange: true,
    allowLevelChange: false,
    minDate: minDate,
    maxDate: maxDate,
    dayStyle: dayStyle,
    fullWidth: true,
    styles: CALENDAR_STYLES,
    "data-testid": "".concat(testId, "-grid")
  }) : /*#__PURE__*/React.createElement(Calendar, {
    value: singleValue,
    onChange: handleSingle,
    month: month,
    onMonthChange: onMonthChange,
    allowLevelChange: false,
    minDate: minDate,
    maxDate: maxDate,
    dayStyle: dayStyle,
    fullWidth: true,
    styles: CALENDAR_STYLES,
    "data-testid": "".concat(testId, "-grid")
  }));
}